.page {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.title {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.tabTitle {
  font-size: 20px;
}

@media (min-width: 720px) {
  .title > div {
    flex: 0 1 320px;
  }
}

.empty {
  color: var(--ink-2);
}

.list {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: var(--surface);
  border: var(--outline);
  border-radius: var(--radius-card);
  box-shadow: var(--shadow-card);
}

.group {
  display: flex;
  flex-direction: column;
}

.heading {
  padding: 10px 18px;
  border-bottom: 1.5px solid var(--ink);
  background: var(--sunk);
  color: var(--ink-2);
  font-size: 13px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.group + .group .heading {
  border-top: 1.5px solid var(--ink);
}

.count {
  font-weight: 500;
}

.hint {
  font-size: 14px;
  color: var(--ink-3);
}
